import dateFnsFormat from 'date-fns/format'
import { es } from 'date-fns/locale'
import dateFnsParse from 'date-fns/parse'
import React from 'react'
import { DateUtils } from 'react-day-picker'
import DayPickerInput from 'react-day-picker/DayPickerInput'
import { Form, Icon } from 'semantic-ui-react'

export default function DateInput(props) {
  // (date: Date?, format: string? | string[]?, locale: string?) ⇒ string
  const formatDate = (date, format, locale = es) => {
    return dateFnsFormat(date, format, { locale })
  }

  // (str: string?, format: string? | string[]?, locale: string?) ⇒ Date | void
  const parseDate = (str, format, locale = es) => {
    const parsed = dateFnsParse(str, format, { locale })

    if (DateUtils.isDate(parsed)) {
      return parsed
    }

    return undefined
  }

  const inputElement = (
    <DayPickerInput
      placeholder={props.placeholder || props.label}
      format={props.format}
      formatDate={formatDate}
      parseDate={parseDate}
      value={props.value || ''}
      onDayChange={value => props.onChange(value)}
    />
  )

  return (
    <Form.Field error={props.error} required={props.required}>
      <label>{props.icon && <Icon name={props.icon} />} {props.label}</label>
      {props.inputStyle ? (
        <div style={props.inputStyle}>{inputElement}</div>
      ) : (
        inputElement
      )}
    </Form.Field>
  )
}

DateInput.defaultProps = {
  label: 'Fecha',
  placeholder: null,
  disabled: false,
  loading: false,
  transparent: false,
  error: false,
  value: null,
  onChange: () => { },
  format: 'dd/MM/yyyy',
}
